






































import { Component, Vue } from 'vue-property-decorator'
import InfinityTable from './components/InfinityTable.vue'

@Component({
  components: {
    InfinityTable,
  },
})
export default class App extends Vue {
  get columnDefs() {
    const colunms: any[] = []
    const keyMaps = Object.keys(this.subjectKeyMaps)
    keyMaps.forEach((key, i) => {
      const column: { [key: string]: any } = {
        filed: key,
        title: this.subjectKeyMaps[key],
        width: 100 + i * 10,
        fixed: '',
        slot: false,
      }
      if (i <= 0) {
        column.width = ''
        column.slot = true
        column.fixed = 'left'
        column.summary = '总计'
      }
      if (key === 'school') {
        column.fixed = 'right'
      }
      if (i === keyMaps.length - 1) {
        column.width = ''
        column.slot = true
        column.fixed = 'right'
      }
      colunms.push(column)
    })
    return colunms
  }

  get subjectKeyMaps(): { [key: string]: string } {
    return {
      id: '学号',
      name: '姓名',
      chinese: '语文',
      math: '数学',
      english: '英语',
      physics: '物理',
      chemistry: '化学',
      computer: '计算机',
      school: '学校',
      operation: '操作',
    }
  }

  public $refs!: {
    table: InfinityTable,
  }
  protected data: ReadonlyArray<any> = []
  protected count: number = 1000

  public mounted() {
    this.generateData()
  }

  public onClick(label: string) {
    alert(label)
  }

  private generateData() {
    const data: any[] = []
    for (let i = 1; i <= this.count; i++) {
      data.push({
        id: i,
        name: `学生${i}`,
        chinese: `${this.randomGrade()}`,
        math: `${this.randomGrade()}`,
        english: `${this.randomGrade()}`,
        physics: `${this.randomGrade()}`,
        chemistry: `${this.randomGrade()}`,
        computer: `${this.randomGrade()}`,
        school: `第${i}中学`,
        operation: '',
      })
    }
    this.data = Object.freeze(data)
    this.$refs.table.renderTable()
  }

  private randomGrade(): string {
    return (Math.random() * 100).toFixed(2)
  }
}
